import React, {useState, useEffect, useRef, useSize} from 'react';
import {LoginApi} from '../../api';
import Modal from 'react-modal';
import CryptoJS from 'crypto-js';
import { Tools } from '../../utils';
import { message } from 'antd';
import SliderCaptcha from 'rc-slider-captcha';
const customStyles = {
  content : {
    display: 'flex',
    flex: 1,
    padding: 0,
    margin: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0.6)',
    top: 0, 
    left: 0, 
    right: 0, 
    bottom: 0,
    zIndex: 999,
  }
};
const a = {
  display: 'flex',
    flex: 1,
    height: '100%',
    padding: 0,
    margin: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(0,0,0,0)',
    top: 0, 
    left: 0, 
    right: 0, 
    bottom: 0,
    zIndex: 1,
    position: 'absolute'
};
const SmsCode = props => {
  const [isVisible, setIsVisible] = useState(false);
  const [waitTime, setWaitTime] = useState(0);
  const [slideCode, setSlideCode] = useState(null);
  const sliderRef = useRef(null);
  const wrapperRef = useRef(null);

  const controlBarWidth = 320;
  const controlButtonWidth = 40;
  const indicatorBorderWidth = 1;
  useEffect(() => {
    if (waitTime > 0) {
      var timer = setInterval(() => {
        setWaitTime(time => time - 1);
      }, 1000);
    }
    return () => {
      clearInterval(timer);
    };
  }, [waitTime]);

  const getMsgCode = async () => {
    try {
      if (!Tools.verifyTel(props.phone)) {
        message.error('请输入正确的手机号');
        return;
      }
      var hash = CryptoJS.MD5(`hyw${props.phone}`).toString();
      let res = await LoginApi.postSmsCheckSend({
        phone: props.phone,
        sign: hash,
      });
      if (res?.success) {
        if (res.data?.result) {
          setWaitTime(60);
        } else {
          setSlideCode(res.data?.slide_code);
          setIsVisible(true);
        }
      }
    } catch (e) {
    }
  };

  return (
    <>
      <button className="code-btn" disabled={waitTime > 0} onClick={getMsgCode}>
        {waitTime > 0 ? `${waitTime}s后重发` : '获取验证码'}
      </button>
      <Modal
        isOpen={isVisible}
        style={customStyles}
        ariaHideApp={false}>
          <div style={a} onClick={()=> setIsVisible(false)}/>
          <SliderCaptcha
            mode="slider"
            tipText={{
              default: '请按住滑块，拖动到最右边',
              moving: '请按住滑块，拖动到最右边',
              error: '验证失败，请重新操作',
              success: '验证成功'
            }}
            errorHoldDuration={1000}
            // 手动设置拼图宽度等于滑块宽度。后面大版本更新会将该模式下的拼图宽度改为和滑块宽度一致。
            puzzleSize={{
              left: indicatorBorderWidth,
              width: controlButtonWidth
            }}
            onVerify={async (data) => {
              console.log(data);
              if (data.x === controlBarWidth - controlButtonWidth - indicatorBorderWidth) {
                try {
                  var hash = CryptoJS.MD5(`100${slideCode}`).toString();
                  let res = await LoginApi.putSmsCheckSend({
                    phone: props.phone,
                    slide_code: hash,
                  });
                  if (res.data && res.success) {
                    setWaitTime(60);
                    setTimeout(() => {
                      setIsVisible(false)
                    }, 1000);
                    return Promise.resolve();
                  } else {
                    return Promise.reject();
                  }
                } catch (e) {
                  return Promise.reject();
                }
              }else{
                return Promise.reject();
              }
            }}
          />
      </Modal>
    </>
  );
};

export default SmsCode;
